import geometry from './defaults/geometry'

/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

const itemCoords = {
  x: 0,
  y: 0,
  h: 100,
  w: 100
}

class Overlap {
  constructor(items, elementsById, globalScale) {
    this.items = items
    this.elementsById = elementsById
    this.itemsById = {}
    this.globalScale = globalScale || 1
    items.forEach((item) => {
      this.itemsById[item.id] = item
    })
    this.boxesById = {}
    this.redrawCoordsById = {}
    this.classes = {}
    this.orderedClasses = {}
    this.uniqueClassesIds = new Set()
    this.initClasses()
    this.calculateClasses()
    this.orderClasses()
  }

  initClasses() {
    this.items.forEach((item) => {
      this.classes[item.id] = new Set([item.id])
      const element = this.elementsById[item.itemId]
      const scale = (element.extendRedraw || 1) * this.globalScale
      const { box } = geometry.boundingPolygon(
        geometry.scaleCoords(itemCoords, scale),
        item.coords,
        item.rotation,
      )
      this.boxesById[item.id] = box
      this.redrawCoordsById[item.id] = {
        x: box.xmin,
        y: box.ymin,
        w: box.xmax - box.xmin,
        h: box.ymax - box.ymin
      }
    })
    this.uniqueClassesIds = new Set(this.items.map((item) => item.id))
  }

  mergeClasses(id1, id2) {
    this.classes[id2].forEach((id) => {
      this.classes[id1].add(id)
    })
    this.classes[id2] = this.classes[id1]
    if (this.uniqueClassesIds.has(id1) && this.uniqueClassesIds.has(id2)) {
      this.uniqueClassesIds.delete(id2)
    }
  }

  calculateClasses() {
    for (let i = 0; i < this.items.length; i++) {
      const item1 = this.items[i]
      for (let j = i + 1; j < this.items.length; j++) {
        const item2 = this.items[j]
        if (this.classes[item1.id] === this.classes[item2.id]) {
          continue
        }
        if (this.boxesById[item1.id].intersect(this.boxesById[item2.id])) {
          this.mergeClasses(item1.id, item2.id)
        }
      }
    }
  }

  orderClasses() {
    this.uniqueClassesIds.forEach((id) => {
      this.orderedClasses[id] = Array.from(this.classes[id])
      this.orderedClasses[id].sort(
        (id1, id2) => this.itemsById[id1].zIndex - this.itemsById[id2].zIndex,
      )
      this.orderedClasses[id].forEach((anotherId) => {
        if (id !== anotherId) {
          this.orderedClasses[anotherId] = this.orderedClasses[id]
        }
      })
    })
  }
}

export default Overlap
